(() => {
  const ready = (fn) => {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn, { once: true });
    else fn();
  };

  ready(() => {
    const results = document.querySelector('results-list');
    const roots = document.querySelectorAll('[data-spectral-collection-search]');
    const seriesMenus = document.querySelectorAll('[data-spectral-series-menu]');
    if (!results || (!roots.length && !seriesMenus.length)) return;

    const normalize = (value) => String(value || '').toLocaleLowerCase().trim();
    const input = roots[0]?.querySelector('[data-spectral-search-input]');
    const submit = roots[0]?.querySelector('[data-spectral-search-submit]');
    let selectedSeries = '';
    let emptyMessage = null;

    const getCards = () => Array.from(results.querySelectorAll('li.product-grid__item'));

    const labelsByHandle = new Map();

    // Series options must reflect ONLY the series present on the current brand's
    // collection page, never every series across every brand in the store.
    // The collection page already only renders products for the current brand,
    // so we derive the option list from the cards actually on the page instead
    // of any remote/global series source. If a card also exposes a brand handle
    // (data-product-brand), use it as an extra guard against mixed collections.
    const collectSeriesForMenu = (menu) => {
      const brandHandle = normalize(menu.dataset.brandHandle);

      labelsByHandle.clear();
      getCards().forEach((card) => {
        const cardBrand = normalize(card.dataset.productBrand);
        if (brandHandle && cardBrand && cardBrand !== brandHandle) return;

        normalize(card.dataset.productSeries).split(',').map(normalize).filter(Boolean).forEach((handle) => {
          if (!labelsByHandle.has(handle)) {
            const label = card.dataset.productSeriesLabel || handle;
            labelsByHandle.set(handle, label);
          }
        });
      });
    };

    const renderSeriesMenu = (menu) => {
      const allButton = menu.querySelector('[data-series-handle=""]');
      const allLabel = allButton?.textContent.trim() || `ALL ${normalize(menu.dataset.brandHandle).replace(/-/g, ' ').toUpperCase()}`;

      menu.replaceChildren();

      const makeButton = (handle, label, active) => {
        const button = document.createElement('button');
        button.type = 'button';
        button.className = 'spectral-series-filter__option' + (active ? ' is-active' : '');
        button.dataset.spectralSeriesFilter = '';
        button.dataset.seriesHandle = handle;
        button.setAttribute('aria-pressed', active ? 'true' : 'false');
        button.textContent = label;
        return button;
      };

      menu.appendChild(makeButton('', allLabel, selectedSeries === ''));
      Array.from(labelsByHandle.entries())
        .sort((a, b) => a[1].localeCompare(b[1], undefined, { sensitivity: 'base' }))
        .forEach(([handle, label]) => menu.appendChild(makeButton(handle, label, selectedSeries === handle)));
    };

    const syncSeriesUi = () => {
      seriesMenus.forEach((menu) => {
        const buttons = Array.from(menu.querySelectorAll('[data-spectral-series-filter]'));
        const label = menu.closest('.spectral-series-filter')?.querySelector('[data-spectral-series-label]');
        const selectedButton = buttons.find((button) => normalize(button.dataset.seriesHandle) === selectedSeries)
          || buttons.find((button) => !normalize(button.dataset.seriesHandle));

        buttons.forEach((button) => {
          const active = button === selectedButton;
          button.classList.toggle('is-active', active);
          button.setAttribute('aria-pressed', active ? 'true' : 'false');
        });
        if (label && selectedButton) label.textContent = selectedButton.textContent.trim();
      });
    };

    const apply = () => {
      const query = normalize(input?.value);
      let matches = 0;

      getCards().forEach((card) => {
        const text = normalize(card.dataset.productSearchText || card.textContent);
        const series = normalize(card.dataset.productSeries).split(',').filter(Boolean);
        const visible = (!query || text.includes(query)) && (!selectedSeries || series.includes(selectedSeries));
        card.hidden = !visible;
        if (visible) matches += 1;
      });

      if (!emptyMessage) {
        emptyMessage = document.createElement('div');
        emptyMessage.className = 'spectral-collection-search-empty';
        emptyMessage.setAttribute('aria-live', 'polite');
        emptyMessage.hidden = true;
        results.parentNode?.appendChild(emptyMessage);
      }

      if (query && selectedSeries) emptyMessage.textContent = `NO PRODUCTS MATCH “${input.value.trim()}” IN THIS SERIES`;
      else if (query) emptyMessage.textContent = `NO PRODUCTS MATCH “${input.value.trim()}”`;
      else if (selectedSeries) emptyMessage.textContent = 'NO PRODUCTS MATCH THIS SERIES';
      else emptyMessage.textContent = '';
      emptyMessage.hidden = matches > 0 || (!query && !selectedSeries);
    };

    input?.addEventListener('input', apply);
    input?.addEventListener('search', apply);
    input?.addEventListener('keydown', (event) => {
      if (event.key === 'Enter') { event.preventDefault(); apply(); }
    });
    submit?.addEventListener('click', (event) => { event.preventDefault(); input?.focus(); apply(); });

    seriesMenus.forEach((menu) => {
      menu.addEventListener('click', (event) => {
        const button = event.target.closest('[data-spectral-series-filter]');
        if (!button || !menu.contains(button)) return;
        event.preventDefault();
        selectedSeries = normalize(button.dataset.seriesHandle);
        syncSeriesUi();
        apply();
      });

      collectSeriesForMenu(menu);
      renderSeriesMenu(menu);
    });

    syncSeriesUi();
    apply();

    const observer = new MutationObserver(() => {
      seriesMenus.forEach((menu) => {
        collectSeriesForMenu(menu);
        renderSeriesMenu(menu);
      });
      syncSeriesUi();
      if (input?.value.trim() || selectedSeries) apply();
    });
    observer.observe(results, { childList: true, subtree: true });
  });
})();